<div class="add-filter">
    <div class="add-filter__toolbar">
        <button type="button" class="add-filter__global-filter-btn" (click)="onOpenTableFilter()">
            <span>Manage table filter</span>
        </button>
        <button type="button" class="add-filter__global-filter-btn" (click)="onOpenGlobalFilter()">
            <!-- <mat-icon aria-hidden="true">tune</mat-icon> -->
            <span>Manage global filter</span>
        </button>
    </div>

    <div class="add-filter__table">
        <div class="add-filter__row add-filter__row--head">
            <span class="add-filter__col add-filter__col--handle"></span>
            <span class="add-filter__col add-filter__col--name">Filter name <span class="mandatory">*</span></span>
            <span class="add-filter__col add-filter__col--type">Type <span class="mandatory">*</span></span>
            <div class="add-filter__col add-filter__col--data">
                <span>Data column <span class="mandatory">*</span></span>
            </div>
            <span class="add-filter__col add-filter__col--actions"></span>
        </div>

        <div class="add-filter__list" cdkDropList [cdkDropListData]="rows" (cdkDropListDropped)="onDrop($event)">
            <div class="add-filter__row" *ngFor="let row of rows; trackBy: trackByRowId" cdkDrag [cdkDragData]="row">
                <span class="add-filter__col add-filter__col--handle" cdkDragHandle>
                    <mat-icon>drag_indicator</mat-icon>
                </span>

                <div class="add-filter__col add-filter__col--name">
                    <input type="text" class="add-filter__input" placeholder="Filter name" [(ngModel)]="row.name"
                        (ngModelChange)="onFieldChange()" />
                    <span class="add-filter__error" *ngIf="isDuplicateName(row)">Must be unique</span>
                </div>

                <div class="add-filter__col add-filter__col--type">
                    <mat-select class="add-filter__select" placeholder="Select type" [(ngModel)]="row.type"
                        (selectionChange)="onTypeChange(row)">
                        <mat-option *ngFor="let opt of controlTypeOptions" [value]="opt.value">{{ opt.label }}</mat-option>
                    </mat-select>
                </div>

                <div class="add-filter__col add-filter__col--data">
                    <!-- The row is recreated when its type changes so Material initializes the
                         selection model with the correct single- or multiple-selection mode. -->
                    <mat-select class="add-filter__select add-filter__data-select" placeholder="Select data column"
                        [multiple]="row.type === 'hierarchal'"
                        panelClass="add-filter-data-column-panel"
                        [attr.aria-label]="'Data column for ' + row.name"
                        [ngModel]="getMainColumnSelection(row)"
                        (ngModelChange)="onMainColumnSelectionChange(row, $event)"
                        (openedChange)="onDataColumnPanelOpenedChange(row, $event)">
                        <mat-select-trigger>
                            <span class="add-filter__data-select-value"
                                [class.add-filter__data-select-value--placeholder]="!getMainColumnLabel(row)">
                                {{ getMainColumnLabel(row) || 'Select data column' }}
                            </span>
                        </mat-select-trigger>

                        <div class="add-filter__data-panel-head" (click)="$event.stopPropagation()">
                            <span class="add-filter__data-panel-title">Selected data column</span>
                            <span class="add-filter__data-panel-count">{{ getSelectedColumnCountLabel(row) }}</span>
                        </div>
                        <div class="add-filter__data-panel-search" (click)="$event.stopPropagation()">
                            <mat-icon aria-hidden="true">search</mat-icon>
                            <input type="text" placeholder="Search columns..."
                                [ngModel]="dataColumnSearchTerm[row.id]"
                                (ngModelChange)="onDataColumnSearchChange(row, $event)"
                                (click)="$event.stopPropagation()" (keydown.space)="$event.stopPropagation()" />
                        </div>

                        <ng-container *ngFor="let group of getFilteredColumnGroups(row); trackBy: trackByColumnGroup">
                            <div class="add-filter__data-group-head" (click)="toggleDataColumnGroup(row, group); $event.stopPropagation()">
                                <mat-icon aria-hidden="true" class="add-filter__data-group-chevron"
                                    [class.add-filter__data-group-chevron--collapsed]="isDataColumnGroupCollapsed(row, group)">expand_more</mat-icon>
                                <span class="add-filter__data-group-name">{{ group.group }}</span>
                                <span class="add-filter__data-group-count">{{ group.columns.length }} column{{ group.columns.length === 1 ? '' : 's' }}</span>
                            </div>

                            <!-- Hierarchal (checkbox, multi-select): still a mat-option (so mat-select's panel actually
                                 opens - MatSelect.open() requires at least one registered mat-option) but the click is
                                 intercepted on an inner wrapper before it reaches mat-option's own click handling, so
                                 selection is driven entirely by our own toggle (never Material's multi-select model,
                                 which didn't reliably support re-selecting after a pick once a getter-derived array
                                 was bound to [ngModel]) and the panel stays open between picks. -->
                            <ng-container *ngIf="row.type === 'hierarchal'; else singleColumnOption">
                                <mat-option *ngFor="let column of group.columns; trackBy: trackByDataColumnOption" [value]="column.key"
                                    class="add-filter__data-option add-filter__data-option--checkbox"
                                    [class.add-filter__data-option--selected]="isColumnSelected(row, column.key)"
                                    [hidden]="isDataColumnGroupCollapsed(row, group)">
                                    <div class="add-filter__data-option-row"
                                        (click)="toggleHierarchalColumn(row, column.key); $event.stopPropagation()">
                                        <span class="add-filter__data-option-checkbox"
                                            [class.add-filter__data-option-checkbox--checked]="isColumnSelected(row, column.key)">
                                        </span>
                                        <span class="add-filter__data-option-body">
                                            <span class="add-filter__data-option-name">{{ column.displayName }}</span>
                                            <span class="add-filter__data-option-dot" *ngIf="getColumnMeta(column)">•</span>
                                            <span class="add-filter__data-option-meta" *ngIf="getColumnMeta(column)">{{ getColumnMeta(column) }}</span>
                                        </span>
                                        <span class="add-filter__data-option-badge" *ngIf="isColumnSelected(row, column.key)">Selected</span>
                                    </div>
                                </mat-option>
                            </ng-container>

                            <!-- Single-select types: plain mat-option, letting Material pick + auto-close the panel. -->
                            <ng-template #singleColumnOption>
                                <mat-option *ngFor="let column of group.columns; trackBy: trackByDataColumnOption" [value]="column.key"
                                    class="add-filter__data-option" [hidden]="isDataColumnGroupCollapsed(row, group)">
                                    <span class="add-filter__data-option-body">
                                        <span class="add-filter__data-option-name">{{ column.displayName }}</span>
                                        <span class="add-filter__data-option-dot" *ngIf="getColumnMeta(column)">•</span>
                                        <span class="add-filter__data-option-meta" *ngIf="getColumnMeta(column)">{{ getColumnMeta(column) }}</span>
                                    </span>
                                </mat-option>
                            </ng-template>
                        </ng-container>
                        <p class="add-filter__data-empty" *ngIf="!getFilteredColumnGroups(row).length">No columns found.</p>
                    </mat-select>
                    <!-- <span class="add-filter__error" *ngIf="needsColumns(row)">Select a label and value column for each data column.</span> -->
                </div>


                <div class="add-filter__col add-filter__col--actions">
                    <button type="button" class="add-filter__icon-btn"
                        [class.add-filter__icon-btn--attention]="needsColumns(row)"
                        [title]="needsColumns(row) ? 'Manage properties - select the label and value columns' : 'Manage properties'"
                        (click)="openProperties(row); $event.stopPropagation()">
                        <mat-icon>tune</mat-icon>
                    </button>
                    <button type="button" class="add-filter__icon-btn add-filter__icon-btn--danger" title="Remove filter"
                        (click)="removeRow(row)">
                        <mat-icon>delete</mat-icon>
                    </button>
                </div>
            </div>
        </div>
    </div>

    <button type="button" class="add-filter__add-btn" (click)="addRow()">
        <mat-icon>add</mat-icon> Add filter
    </button>

    <p class="add-filter__summary">{{ summaryText }}</p>

    <app-property-panel [open]="!!activeRow" title="Filter properties" width="400px" [fields]="propertyFields"
        [values]="activePropertyValues" (valueChange)="onPropertyValueChange($event)" (closed)="closeProperties()">
    </app-property-panel>
</div>

<app-modal [maximizable]="true" [inViewport]="true" #globalFilterModal class="modal-demo global-filter-popup"
    (closeModal)="onGlobalFilterCancelled()">
    <ng-container class="app-modal-header">Manage global filter</ng-container>
    <ng-container class="app-modal-body">
        <app-global-filter-modal #globalFilterModalBody [columnOptions]="globalFilterColumnOptions"
            (cancelled)="onGlobalFilterCancelled()" (conditionsSaved)="onGlobalFilterSaved($event)">
        </app-global-filter-modal>
    </ng-container>
</app-modal>

<app-modal [maximizable]="true" [inViewport]="true" #tableFilterModal class="modal-demo global-filter-popup"
    (closeModal)="onTableFilterCancelled()">
    <ng-container class="app-modal-header">Manage table filter</ng-container>
    <ng-container class="app-modal-body">
        <app-global-filter-modal #tableFilterModalBody mode="table" [columnOptions]="globalFilterColumnOptions"
            (cancelled)="onTableFilterCancelled()" (conditionsSaved)="onTableFilterSaved($event)">
        </app-global-filter-modal>
    </ng-container>
</app-modal>
